import { registerArtifactPayload } from '@/features/documentPreview/artifactPayloadStore.js'
import { citationDocTitle, citationLocationLabel } from './citationLabel'
import { focusTarget, previewKind, previewPayload } from './citationPreviewPayload'

export function openCitationPreview(preview, citation, targetIndex = -1) {
  if (citation?.kind === 'web' && citation.url) {
    window.open(citation.url, '_blank', 'noopener,noreferrer')
    return
  }
  if (!preview || !citation?.doc_id) return

  const kind = previewKind(citation)
  const fileName = citationDocTitle(citation)
  const focus = focusTarget(citation, targetIndex)
  const artifact = {
    artifactId: citation.doc_id,
    kind,
    fileName,
    description: citationLocationLabel(citation, targetIndex),
    focusPage: focus.focusPage,
    focusSectionId: focus.focusSectionId,
    payload: previewPayload(citation, kind, targetIndex),
  }

  registerArtifactPayload(artifact)
  preview.openPreview(artifact)
}
